import React from "react";
import { Link } from "react-router-dom";
import {
    Box,
    Typography,
    Card,
    CardActionArea,
    CardContent,
    CardMedia,
} from "@mui/material";
import { news } from "./NewsData";
import AdSense from "../../components/AdSense";
import SEO from "../../components/SEO/SEO";
import PageHero from "../../components/PageHero/PageHero";
import AppDownloadCTA from "../../components/AppDownloadCTA/AppDownloadCTA";
import { pageMeta } from "../../seo/pageMeta";

export default function News() {
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                gap: 3,
                maxWidth: 1400,
                mx: "auto",
                px: 2,
                py: { xs: 4, md: 6 },
                background:
                    "linear-gradient(180deg, rgba(240,248,240,0.45) 0%, #ffffff 28%)",
            }}
        >
            <SEO {...pageMeta.news} />

            <Box
                className="side-ad"
                sx={{
                    width: 160,
                    flexShrink: 0,
                    position: "sticky",
                    top: 100,
                    alignSelf: "flex-start",
                    display: { xs: "none", lg: "block" },
                }}
            >
                <AdSense slot="9786570260" />
            </Box>

            <Box sx={{ maxWidth: 900, width: "100%" }}>
                <PageHero
                    eyebrow="Stay Informed"
                    title="Islamic & World News for Muslims"
                    subtitle="Curated headlines alongside your Quran and deen journey. For deeper Islamic learning, explore our blogs on Salah, dua, Ramadan, and the Holy Quran."
                    breadcrumbs={[
                        { label: "Home", to: "/" },
                        { label: "News" },
                    ]}
                />

                {Object.entries(news).map(([slug, article], index) => (
                    <React.Fragment key={slug}>
                        <Card sx={{ mb: 3, overflow: "hidden" }}>
                            <CardActionArea component={Link} to={`/news/${slug}`}>
                                {article.image && article.image !== "None" && (
                                    <CardMedia
                                        component="img"
                                        height="220"
                                        image={article.image}
                                        alt={article.title}
                                        sx={{ objectFit: "cover" }}
                                    />
                                )}
                                <CardContent sx={{ p: 3 }}>
                                    <Typography
                                        variant="h5"
                                        component="h2"
                                        sx={{ mb: 1.5, fontWeight: 600, lineHeight: 1.35 }}
                                    >
                                        {article.title}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            color: "text.secondary",
                                            lineHeight: 1.7,
                                            display: "-webkit-box",
                                            WebkitLineClamp: 3,
                                            WebkitBoxOrient: "vertical",
                                            overflow: "hidden",
                                        }}
                                    >
                                        {article.paragraph}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            mt: 2,
                                            color: "primary.main",
                                            fontWeight: 700,
                                        }}
                                    >
                                        Read more →
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>

                        {(index + 1) % 3 === 0 && (
                            <Box sx={{ my: 3 }}>
                                <AdSense slot="2566597353" />
                            </Box>
                        )}
                    </React.Fragment>
                ))}

                <AppDownloadCTA
                    title="News + Quran learning in one place"
                    subtitle="Follow the news, then open Quran Chat Buddy for AI Quran guidance, Salah prayer times, and daily ayat reminders."
                />
            </Box>

            <Box
                className="side-ad"
                sx={{
                    width: 160,
                    flexShrink: 0,
                    position: "sticky",
                    top: 100,
                    alignSelf: "flex-start",
                    display: { xs: "none", lg: "block" },
                }}
            >
                <AdSense slot="9786570260" />
            </Box>
        </Box>
    );
}
